// extracted by mini-css-extract-plugin
export default {"outer":"styles_outer__Hocdp","serviceField":"styles_serviceField__yFJ1k","icon":"styles_icon__QSPDz","activeIcon":"styles_activeIcon__xZeb5","active":"styles_active__bE-gL"};